<app-party-quick-create-dialog
    [visible]="displayModal"
    (visibleChange)="onVisibilityChanged($event)"
    mode="company"
    [record]="company"
    [countries]="countries"
    [owningCompany]="owningCompany"
    [titleOverride]="dialogHeader"
    [submitLabel]="submitButtonLabel"
    (created)="onDialogCompleted($event)"
    (failed)="onDialogFailed()">
</app-party-quick-create-dialog>
